import { createAction } from '@reduxjs/toolkit';
import { ISupplier } from '../../../../dto';
import { ACT_SET, MN_SUPPLIERS, TYPE_ELEMENT } from '../../../../common';

export const setSupplier = createAction<ISupplier>(
  `${MN_SUPPLIERS}/${TYPE_ELEMENT}/${ACT_SET}`,
);
